export default "__VITE_ASSET__DdMTUkS0__"